import { render, staticRenderFns } from "./edit-items.vue?vue&type=template&id=49519bc4&scoped=true&"
import script from "./edit-items.vue?vue&type=script&lang=ts&"
export * from "./edit-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49519bc4",
  null
  
)

export default component.exports